<template>
  <ModalDialog
    ref="dialog"
    title="Update Password"
    icon="fa-key"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="userForm" :labelColumnSize="2">
      <FormRow label="New Password"><FormInputText type="password" v-model="user.password" field="password" /></FormRow>
      <FormRow label="Confirm Password"><FormInputText type="password" v-model="user.confirmPassword" field="confirmPassword" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: "UserUpdatePasswordDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    userId: Number
  },
  data() {
    return {
      user: { },
      userForm: {},
      submitting: false
    }
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.user = { }
      this.userForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var userData = _.cloneDeep(this.$data.user)
      
      var updateData = _.pick(userData, ['password', 'confirmPassword'])

      this.$apiService.userService.updateUser(this.userId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.userForm = this.processFormResponse(err)
        })


    },
  }
}
</script>